export default function OrientationOverlay({ isVisible }) {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-md flex flex-col items-center justify-center px-6 text-center text-white">
      <svg
        className="w-16 h-16 mb-4 animate-bounce text-rose-300"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
        />
      </svg>
      <h3 className="text-xl font-medium mb-2">Please Rotate Your Screen</h3>
      <p className="text-sm text-slate-300 max-w-xs">
        For the best experience, please hold your phone vertically in portrait
        mode.
      </p>
    </div>
  );
}
